import { render, staticRenderFns } from "./IconCompleteV52.vue?vue&type=template&id=6a2724a6"
import script from "./IconCompleteV52.vue?vue&type=script&lang=js"
export * from "./IconCompleteV52.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports